<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
            <a-range-picker
              v-model="dateRange"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              @change="onChange"
            />
          </div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'sub_program.acps_name_foreign'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.ac_term.term_name }}</td>
          <td>{{ record.ac_term.branch.branch_name_en }}</td>
          <td>{{ record.promotion_rate }}</td>
          <td>{{ record.promotion_start_date }}</td>
          <td>{{ record.promotion_expiry_date }}</td>
          <td>{{ record.remark }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'promotion-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('promotion.termname') },
        { name: this.$t('promotion.branchname') },
        { name: this.$t('promotion.rate') },
        { name: this.$t('promotion.startdate') },
        { name: this.$t('promotion.expirydate') },
        { name: this.$t('promotion.remark') },
        { name: this.$t('actions'), style: 'text-align:center; width:1px' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('promotion', ['resources', 'pagination']),

    dateRange: {
      get() {
        return this.$store.state.promotion.date_range
      },
      set(newValue) {
        this.$store.commit('promotion/SET_DATE_RANGE', newValue)
      }
    },
    search: {
      get() {
        return this.$store.state.promotion.search
      },
      set(newValue) {
        this.$store.commit('promotion/SET_SEARCH', newValue)
        this.$store.commit('promotion/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('promotion/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('promotion/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'promotion-edit',
        params: { id: record.promotion_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('promotion/destroy', record.promotion_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    onChange(date, dateString) {
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function() {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
